import { Dispatch } from '@reduxjs/toolkit';

import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { ExternalIntegration } from 'dashboard/models/external-integration';
import { Importer } from 'dashboard/models/importer';
import { setExternalIntegration } from 'dashboard/redux/actions/external-integrations';
import { saveImporter } from 'dashboard/redux/actions/importer';
import { ApiEndpoint } from 'lib/interfaces/api';

export const loadImporter = (importerId: string) => {
  return async (dispatch: Dispatch) => {
    const response = await SessionClientDashboard.getResource<Importer>(
      ApiEndpoint.ImporterPipeline,
      importerId,
    );
    dispatch(saveImporter(response.data));
    dispatch(
      setExternalIntegration(
        response.included?.find((o) =>
          o.type.startsWith('external-integration/'),
        ) as ExternalIntegration,
      ),
    );
    return response;
  };
};
